import { render, staticRenderFns } from "./MagicLinkConfirmationModal.vue?vue&type=template&id=f1298ccc&scoped=true&"
import script from "./MagicLinkConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./MagicLinkConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkConfirmationModal.vue?vue&type=style&index=0&id=f1298ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1298ccc",
  null
  
)

export default component.exports